import React, { useEffect, useState } from "react";
import LastActivity from "../../Last_Activity/LastActivity";
import AnswerWrapper from "./AnswerWrapper";

const ResponseContainer = ({
  questionId,
  setAnswer,
  categoryData,
  prevAnswer,
  ...rest
}) => {
  const [colorId, setColorId] = useState(0);
  const [lastupdated, setLastUpdated] = useState({});
  const [rateOfComplete, setRateOfComplete] = useState();
  const [answerId, setAnswerId] = useState(0);
  const [lastUpdatedQn, setLastUpdatedQn] = useState(0);

  const setAnswerData = (answerId, subcategoryId = null, rate = null) => {
    const data = {
      subcategory_id: subcategoryId,
      answer_id: answerId,
      rating: rate,
    };
    setAnswer(data);
  };

  const rateChart = () => {
    const ratings = [];
    for (let i = 1; i <= 5; i++) {
      ratings.push(
        <div
          key={i}
          className={
            rateOfComplete === i ? "selectedRating rate-number" : "rate-number"
          }
          onClick={() => {
            setRateOfComplete(i);
            setAnswerData(colorId, categoryData?.category_id, i);
          }}
        >
          {i}
        </div>
      );
    }
    return ratings;
  };

  useEffect(() => {
    // updating color based on previous data
    if (prevAnswer) {
      if (categoryData?.category) {
        prevAnswer &&
          prevAnswer.map((prev) => {
            if (prev?.category === categoryData?.category_id) {
              setColorId(prev?.answer);
              setRateOfComplete(prev?.rating);
              setLastUpdated({
                updatedAt: prev?.updated_at,
                updatedBy: prev?.updated_by,
              });
            }
          });
      } else {
        setColorId(prevAnswer.answer);
        setRateOfComplete(prevAnswer?.rating);
      }
    }
  }, [prevAnswer]);

  const handleAnswerClick = (id, rate = null) => {
    categoryData
      ? setAnswerData(id, categoryData?.category_id, rate)
      : setAnswerData(id, null, rate);
    setAnswerId(id);
    setLastUpdatedQn(questionId);
  };

  return (
    <div className="response-block">
      <div
        className={`response-wrapper${
          categoryData?.category ? "" : " response-wrapper--plain"
        }`}
      >
        {categoryData?.category ? (
          <div className="response-category-name">{categoryData.category}</div>
        ) : null}
        <div className="response-container">
          <AnswerWrapper
            setRateOfComplete={setRateOfComplete}
            handleAnswerClick={handleAnswerClick}
            questionId={questionId}
            colorId={colorId}
            answerId={answerId}
            categoryData={categoryData}
          />
        </div>
        {Object.keys(lastupdated).length > 0 ? (
          <LastActivity
            updatedAt={lastupdated?.updatedAt}
            qnId={questionId}
            category={categoryData}
            {...rest}
          />
        ) : (
          <span aria-hidden="true" />
        )}
      </div>
      {colorId == 2 && (
        <div className="rate">
          <span>
            Rate on a scale of 1 to 5, 1 being least complete and 5 being most
            complete.
          </span>
          <div className="ratingButtons">{rateChart()}</div>
        </div>
      )}
    </div>
  );
};

export default ResponseContainer;
